// @ts-nocheck
import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { KeyIcon, XMarkIcon } from '@heroicons/react/24/outline';
import Password from './Password';

export default function ModalSettings({ open, setOpen }) {
  const closeModal = () => setOpen(false);

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-950/45 backdrop-blur-[2px]" />
        </Transition.Child>

        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 sm:p-6">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-200"
              enterFrom="opacity-0 translate-y-3 scale-95"
              enterTo="opacity-100 translate-y-0 scale-100"
              leave="ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0 scale-100"
              leaveTo="opacity-0 translate-y-3 scale-95"
            >
              <Dialog.Panel className="flex max-h-[calc(100vh-2rem)] w-full max-w-xl flex-col overflow-hidden rounded-3xl border border-white/70 bg-white text-left shadow-2xl">
                <div className="flex shrink-0 items-start justify-between border-b border-gray-100 px-6 py-5 sm:px-8 sm:py-6">
                  <div className="flex min-w-0 items-start gap-4">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-emerald-50 text-green-cl">
                      <KeyIcon className="h-6 w-6" />
                    </span>

                    <div className="min-w-0">
                      <Dialog.Title as="h3" className="text-xl font-extrabold tracking-tight text-gray-950">
                        Alterar palavra-passe
                      </Dialog.Title>
                      <p className="mt-1 text-sm leading-5 text-gray-500">
                        Atualize as suas credenciais de acesso de forma segura.
                      </p>
                    </div>
                  </div>

                  <button
                    type="button"
                    onClick={closeModal}
                    className="ml-4 rounded-xl p-2 text-gray-400 transition hover:bg-gray-100 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-green-cl"
                    aria-label="Fechar"
                  >
                    <XMarkIcon className="h-5 w-5" />
                  </button>
                </div>

                <Password onCancel={closeModal} />
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
